/* eslint-disable @typescript-eslint/no-unnecessary-condition -- will add another entity in the future */
import { MentionComponentProps } from "shared/components/Editor/core/extentions/mentions/types";
import { EditorUserMention } from "./user";

export const EditorMentionsRoot = (props: MentionComponentProps) => {
  const { entity_identifier, entity_name } = props;

  if (entity_name === "partner_user")
    return <EditorUserMention id={entity_identifier} />;

  //another entity in the future
  return null;
};
